import { getAttachUrl } from 'reactApp/modules/attaches/attaches.helpers';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { getEncodePath } from 'reactApp/utils/urlHelper';

const getId = (item, storage: EStorageType) => {
    const { isStock, isPublic } = getStorage(storage);

    const id = item.id?.replace('/', '');

    if (isPublic) {
        return `/${item.weblink}`;
    }

    if (isStock) {
        return item.id
    }

    return encodeURIComponent(id);
}

export const getPathToNewTab = (item, storage, userEmail: string | null): string => {
    const { 
        isHome, 
        isSharedIncoming, 
        isSearch, 
        isSharedLinks, 
        isSharedAutodelete, 
        isFeed, 
        isDocuments, 
        isStart, 
        isFavorites, 
        isAttaches, 
        isAlbums,
    } = getStorage(storage);

    const id = getId(item, storage);

    if (
        isHome ||
        isSharedIncoming ||
        isSearch ||
        isSharedLinks ||
        isSharedAutodelete ||
        isFeed ||
        isDocuments ||
        isStart ||
        (isFavorites && item.ext && item.ext.toLowerCase() === 'pdf') ||
        (isFavorites && item.isFolder)
    ) {
        return `home${getEncodePath(item.home) || ''}`;
    }
    
    if (isAttaches) {
        return getAttachUrl(item.id, userEmail, true);
    }
    
    if (isAlbums) {
        return `${storage}/${item.parent}/${id}`;
    }

    return `${storage}/${id}`;
};
